import { FC } from 'react'

import InfraLogo from '../../assets/infra.png'

import { Box } from '@mui/material'
import { keyframes } from '@mui/material/styles'

interface Props {

}

export const Loading: FC<Props> = () => {
    const pulse = keyframes({
        '0%': { transform: 'scale(1)' },
        '50%': { transform: 'scale(1.2)' },
        '100%': { transform: 'scale(1)' }
    })

    return (
        <Box
            sx={(theme) => ({
                backgroundColor: theme.palette.background.default,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center'
            })}
        >
            <Box
                sx={{
                    borderRadius: '20px',
                    padding: '40px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <Box
                    component="img"
                    src={InfraLogo}
                    alt="Logo Infra"
                    sx={(theme) => ({
                        minWidth: 320,
                        width: '30%',
                        animation: `${pulse} 2000ms ${theme.transitions.easing.sharp} infinite`
                    })}
                />
            </Box>
        </Box>
    )
}
